import * as types from './types'
import ChatResource from '@/common/resources/Chat'

export const actions = {
	getMessages ({ commit }) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			commit(types.CLEAR_THREAD)
			ChatResource.getThreads().then((result) => {
				if (result.data.success) {
					result.data.threads.forEach((thread) => {
						commit(types.NEW_THREAD, thread)
					})
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					if (result.data.error === 'No threads found.') {
						resolve()
					} else {
						reject(new Error('Dont know'))
					}
				}
			}).catch((e) => {
				commit('LOADER_OUT')
				reject(e)
			})
		})
	},
	newThread ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			ChatResource.newThread(data.request).then((result) => {
				if (result.data.success) {
					const date = new Date()
					const stringDate = date.getDate() + '/' + computeMonth(date.getMonth()) + '/' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes()
					commit(types.NEW_THREAD, {
						id: result.data.thread_id,
						title: data.request.title,
						created_at: stringDate,
						client: {
							id: data.request.user_id
						},
						messages: [
							{
								user: data.user,
								body: data.request.body,
								created_at: stringDate
							}
						]
					})
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('coucou'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	newMessage ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			ChatResource.newMessage(data.request).then((result) => {
				if (result.data.success) {
					const date = new Date()
					const stringDate = date.getDate() + '/' + computeMonth(date.getMonth()) + '/' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes()
					commit(types.NEW_MESSAGE, {
						id: data.request.thread_id,
						message: {
							user: {
								id: data.request.user_id,
								first_name: data.side.first_name,
								last_name: data.side.last_name
							},
							body: data.request.body,
							created_at: stringDate
						}
					})
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Une erreur est survenue'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	},
	sendAppointmentRequest ({ commit }, data) {
		return new Promise((resolve, reject) => {
			commit('LOADER_IN')
			ChatResource.appointmentRequest(data.request).then((result) => {
				if (result.data.success) {
					const date = new Date()
					const stringDate = date.getDate() + '/' + date.getMonth() + '/' + date.getFullYear() + ' ' + date.getHours() + ':' + date.getMinutes()
					commit(types.NEW_THREAD, {
						id: result.data.thread_id,
						title: 'Nouvelle demande de RDV',
						created_at: stringDate,
						client: {
							id: data.side.user.id
						},
						messages: [
							{
								user: data.side.user,
								appointment_detail: data.request.appointment_detail,
								appointment_day: data.request.appointment_day,
								appointment_moment: data.request.appointment_moment,
								appointment_subject: data.request.appointment_subject,
								created_at: stringDate
							}
						]
					})
					commit('LOADER_OUT')
					resolve()
				} else {
					commit('LOADER_OUT')
					reject(new Error('Un problème est survenu'))
				}
			}).catch((error) => {
				commit('LOADER_OUT')
				reject(error)
			})
		})
	}
}

const computeMonth = function (n) {
	n = parseInt(n) + 1
	return ('00' + n).slice(-2)
}



// WEBPACK FOOTER //
// ./src/common/store/Chat/actions.js